module.exports = __webpack_public_path__ + "static/media/logo-external.58742a14.png";